import { render, staticRenderFns } from "./service-info.vue?vue&type=template&id=27ac7d6c&scoped=true&"
import script from "./service-info.vue?vue&type=script&lang=js&"
export * from "./service-info.vue?vue&type=script&lang=js&"
import style0 from "./service-info.vue?vue&type=style&index=0&id=27ac7d6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ac7d6c",
  null
  
)

export default component.exports